export const LOADING_ANNOUNCEMENT_DATA = "LOADING_ANNOUNCEMENT_DATA";
export const SUCCESS_ANNOUNCEMENT_DATA = "SUCCESS_ANNOUNCEMENT_DATA";
